import getEncodedVerifierKey from './getEncodedVerifierKey'

export const getVerifierState = ({ clientId }) => {
  const key = getEncodedVerifierKey(clientId)
  const value = JSON.parse(sessionStorage.getItem(key))
  return value
}
